import type { Workspace } from './types';

// Action Constants
export const WORKSPACE_WORKSPACES_LOADED = 'WORKSPACE_WORKSPACES_LOADED';
export const WORKSPACE_WORKSPACE_SELECTED = 'WORKSPACE_WORKSPACE_SELECTED';
export const WORKSPACE_WORKSPACE_CREATED = 'WORKSPACE_WORKSPACE_CREATED';
export const WORKSPACE_WORKSPACE_UPDATED = 'WORKSPACE_WORKSPACE_UPDATED';
export const WORKSPACE_LOADING_CHANGED = 'WORKSPACE_LOADING_CHANGED';

// Action Interfaces
export interface IWorkspacesLoadedAction {
  type: typeof WORKSPACE_WORKSPACES_LOADED;
  payload: { workspaces: Workspace[] };
}

export interface IWorkspaceSelectedAction {
  type: typeof WORKSPACE_WORKSPACE_SELECTED;
  payload: { workspaceId: string };
}

export interface IWorkspaceCreatedAction {
  type: typeof WORKSPACE_WORKSPACE_CREATED;
  payload: { workspace: Workspace };
}

export interface IWorkspaceUpdatedAction {
  type: typeof WORKSPACE_WORKSPACE_UPDATED;
  payload: { workspace: Workspace };
}

export interface IWorkspaceLoadingChangedAction {
  type: typeof WORKSPACE_LOADING_CHANGED;
  payload: { isLoading: boolean };
}

// Union type for all workspace actions
export type WorkspaceActionTypes =
  | IWorkspacesLoadedAction
  | IWorkspaceSelectedAction
  | IWorkspaceCreatedAction
  | IWorkspaceUpdatedAction
  | IWorkspaceLoadingChangedAction;
